import React, { useContext, createContext, useState, Dispatch, SetStateAction, FC } from 'react';

export interface IUserDetail {
  userKey: string;
  firstName: string;
  lastName: string;
  email: string;
  eventRegistrationId: string;
}

export interface IUserContext {
  userDetail: IUserDetail;
  setUserDetail: Dispatch<SetStateAction<IUserDetail>>;
}

export const UserContext = createContext<IUserContext>(null as any);
const UserWrapper: FC = ({ children }) => {
  const [userDetail, setUserDetail] = useState<IUserDetail>(null as any);
  return (
    <UserContext.Provider
      value={{
        userDetail,
        setUserDetail,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
const useUserContext = () => useContext<IUserContext>(UserContext);

export { UserWrapper, useUserContext };
